<template>
  <div class="footer-box">
    <button class="btn btn-primary btn-block" @click="emit('next')"><slot>Next</slot></button>
  </div>
</template>
<script lang="ts" setup>
const emit = defineEmits(['next']);
</script>
